@use '../../../../../app/styles/common/colors';
@use '../../../../../app/styles/common/mixins';

.modal {
  .modalHeader {
    position: absolute;
    top: 0;
    left: 0;

    padding: 16px 16px 0;

    @include mixins.mobileXL {
      padding: 32px 32px 0;
    }
  }

  .modalContainer {
    background-color: colors.$blueSecondary;
    padding: 0;
    gap: 0;
  }
}

.imageWrapper {
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 24px 0;
  width: 100%;

  @include mixins.mobileXL {
    padding: 32px 0 12px;
  }

  @include mixins.laptop {
    padding: 32px 0;
  }
}

.imageContent {
  box-sizing: border-box;
  width: 150px;
  height: 150px;
  padding: 7px 16px;

  @include mixins.mobileXL {
    height: 200px;
    width: 200px;
    padding: 9px 21px;
  }

  @include mixins.laptop {
    height: 180px;
    width: 180px;
    padding: 8px 20px;
  }

  img {
    height: auto;
    max-width: 100%;
  }
}

.textContent {
  background-color: colors.$white;
  border-radius: 24px 24px 0 0;
  padding: 24px 16px 16px;

  @include mixins.laptop {
    padding: 40px 32px 32px;
  }

  @include mixins.laptop {
    padding: 32px;
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    white-space: pre-line;

    @include mixins.tablet {
      white-space: initial;
    }
  }

  .description {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin-top: 8px;

    @include mixins.mobileXL {
      white-space: pre-line;
    }
  }
}

.button {
  height: 50px;
  margin-top: 24px;

  @include mixins.mobileXL {
    margin-top: 40px;
  }

  @include mixins.laptop {
    margin-top: 32px;
  }
}
